"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _newReports = require("@/api/bookSpace/newReports");
var _selectTemplate = _interopRequireDefault(require("./components/selectTemplate.vue"));
var _bookingStatus = _interopRequireDefault(require("./components/bookingStatus.vue"));
var _ftDialog = _interopRequireDefault(require("./components/ftDialog"));
var _checkDialog = _interopRequireDefault(require("./components/checkDialog"));
var _newReportsDialog = _interopRequireDefault(require("@/views/booking/bookingSpace/components/newReportsDialog.vue"));
var _vgmImportDialog = _interopRequireDefault(require("./components/vgmImportDialog"));
var _importDialog = _interopRequireDefault(require("./components/importDialog"));
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
var _vesselVoyage = _interopRequireDefault(require("./components/vesselVoyage"));
var _adjustVesselMsg = _interopRequireDefault(require("./components/adjustVesselMsg"));
var _cancelBookingListMsg = _interopRequireDefault(require("./components/cancelBookingListMsg"));
var _vue = require("@handsontable/vue");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _indexHotOpt = _interopRequireDefault(require("./components/indexHotOpt"));
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
var _vuex = require("vuex");
var _copyBook = _interopRequireDefault(require("./components/copyBook"));
var _combinDialog = _interopRequireDefault(require("./components/combinDialog"));
var _newManifestEDI = require("@/api/bookSpace/newManifestEDI");
var _ClearableTextInput = _interopRequireDefault(require("@/components/ClearableTextInput"));
var _index = _interopRequireDefault(require("@/components/Transfer/index.vue"));
var _date = require("@/utils/date");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  activated: function activated() {
    // 在缓存状态下重新激活时调用
    this.handleSearchSelect();
  },
  components: {
    HotColumn: _vue.HotColumn,
    HotTable: _vue.HotTable,
    Pagination: _Pagination.default,
    customRenderer: _indexHotOpt.default,
    sailSchedule: _SailScheduleOne.default,
    vesselVoyage: _vesselVoyage.default,
    vgmImportDialog: _vgmImportDialog.default,
    ftDialog: _ftDialog.default,
    newReportsDialog: _newReportsDialog.default,
    copyBook: _copyBook.default,
    checkDialog: _checkDialog.default,
    bookingStatus: _bookingStatus.default,
    selectTemplate: _selectTemplate.default,
    importDialog: _importDialog.default,
    combinDialog: _combinDialog.default,
    adjustVesselMsg: _adjustVesselMsg.default,
    cancelBookingListMsg: _cancelBookingListMsg.default,
    ClearableTextInput: _ClearableTextInput.default,
    transfer: _index.default
  },
  data: function data() {
    var _this = this;
    return (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      targetDataOne: [],
      sourceData: [],
      transferDialogVisible: false,
      tableKey: 0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
            minDate = _ref.minDate;
          _this.selectDate = minDate.getTime();
          if (maxDate) {
            _this.selectDate = '';
          }
        },
        disabledDate: function disabledDate(time) {
          if (_this.selectDate !== '') {
            var one = 60 * 24 * 3600 * 1000;
            var minTime = _this.selectDate - one;
            var maxTime = _this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      mainId: '',
      //主单id
      combinDialogDialog: false,
      dataInfo: [],
      //请求头
      polCopy: '',
      importDialog: false,
      selectList: [],
      viewVisible: false,
      viewMainId: '',
      newReportData: {},
      newReportSearchForm: {
        spliteCombinType: '',
        confirmFlag: '',
        id: ''
      },
      blNo: '',
      pol: '',
      copyId: '',
      copyVisible: false,
      ftDialogVisible: false,
      newReportsDialogVisible: false,
      vgmImportDialogVisible: false,
      adVesselMsg: '',
      adjustVesselMsgVisible: false,
      bookingHeadWebId: '',
      vesselVoyageDialogVisible: false,
      headers: {
        "Content-Type": "multipart/form-data"
      },
      fileList: [],
      checkedItems: [],
      selectAll: false,
      selectedItems: [],
      printFlag: false,
      isShow: true,
      tableLoading: false,
      sailScheduleDialogVisible: false,
      dataTime: [],
      listQuery: {
        pol: "",
        pod: "",
        bkNo: "",
        etd: "",
        etdTo: "",
        currentPage: 1,
        pageSize: 100,
        blNo: "",
        remark: "",
        status: "",
        vesselCode: "",
        vesselName: "",
        vesselNameCn: "",
        voyageNo: "",
        voyageLeg: "",
        createdFrom: "",
        createdTo: ""
      },
      bookingList: [],
      filterForm: {
        keyword: '',
        portOfDeparture: '',
        radio: '1',
        selectTime: '2',
        serviceLineCode: ''
      },
      operateList: [{
        name: '拷贝',
        nameEn: 'Copy',
        visible: true
      }, {
        name: '批量拷贝',
        nameEn: 'Batch Copy',
        visible: true
      }, {
        name: '单票F/T申请',
        nameEn: 'F/T Apply',
        clickName: 'handleOpenFt',
        visible: true
      }, {
        name: '单票F/T导出',
        nameEn: 'F/T Export',
        clickName: 'handleExport',
        visible: true
      }, {
        name: '取消订舱',
        nameEn: 'Cancel Booking',
        visible: true
      }, {
        name: '合报分出',
        nameEn: 'Split BL',
        visible: true
      }, {
        name: '分报合出',
        nameEn: 'Combine BL',
        visible: true
      }, {
        name: '分报分出',
        nameEn: 'Split Booking',
        visible: true
      },
      // {name:'拆单补料',nameEn:'Quick Split',visible: true},
      // {name:'并单自动确认',nameEn:'Quick Combine',visible: true},
      {
        name: '补料核对',
        nameEn: 'S/I Compare',
        visible: true
      }, {
        name: '订舱撤回',
        nameEn: 'Withdraw Booking',
        visible: true
      }, {
        name: '提单预览',
        nameEn: 'Preview',
        visible: true
      }, {
        name: 'SO预览',
        nameEn: 'SO',
        visible: true
      }],
      currentFlag: '1',
      timeList: [{
        value: '1',
        labelZh: '开航时间',
        labelEh: 'POL ETD'
      }, {
        value: '2',
        labelZh: '创建时间',
        labelEh: 'CREATED TIME'
      }],
      options: [{
        value: '1',
        labelZh: '及后一周内',
        labelEh: 'saillingDate'
      }, {
        value: '2',
        labelZh: '及后两周内',
        labelEh: 'Within the next two weeks'
      }, {
        value: '3',
        labelZh: '及后三周内',
        labelEh: 'Within the next three weeks'
      }, {
        value: '4',
        labelZh: '及后四周内',
        labelEh: 'Within the next four weeks'
      }],
      multipleSelection: [],
      total: 0,
      tableData: [],
      totalCrnt: '',
      cancelBookingListMsgVisible: false,
      cancelBookingListMsg: ''
    }, "tableLoading", false), "currentId", '2c2881d0904e3126019058d156c7013d'), "rules", {
      pol: [{
        required: true,
        message: this.$t('filter.pleaseEnterKeyWord'),
        trigger: 'change'
      }],
      pod: [{
        required: true,
        message: this.$t('filter.pleaseEnterKeyWord'),
        trigger: 'change'
      }],
      time: [{
        required: true,
        message: this.$t('filter.pleaseEnterKeyWord'),
        trigger: 'blur'
      }]
    }), "bookingType2List", []), "biTypeList", []), "hotSettings", {
      dragCheck: true,
      height: 'calc(100vh - 215px)',
      width: '100%',
      stretchH: 'all',
      manualColumnResize: true,
      language: 'zh-CN',
      licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
      readOnly: true,
      columnSorting: true,
      showSelection: false,
      fragmentSelection: 'cell',
      copyPaste: false
    }), "radio", '1'), "selectedRows", []);
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])), {}, {
    dynamicWidth: function dynamicWidth() {
      return this.language === 'en' ? '350' : '250';
    } // isShow(){
    //     return this.userInfo.bookingViewType
    // }
  }),
  created: function created() {
    var _this2 = this;
    this.initData();
    this.$dictionary.get(['BOOKING_WEB_STATUS_COM', 'DOC_BK_TYPE', 'BLTYPE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this2.bookingType2List = res.DOC_BK_TYPE ? res.DOC_BK_TYPE : [];
      _this2.biTypeList = res.BLTYPE ? res.BLTYPE : [];
      _this2.bookingList = res.BOOKING_WEB_STATUS_COM ? res.BOOKING_WEB_STATUS_COM : [];
    });
    // 从 localStorage 获取列顺序信息
    var order = JSON.parse(localStorage.getItem('sourceOrder'));
    // 如果有订单顺序信息，根据 localStorage 中的顺序重新排序 sourceData
    if (order) {
      // 检查 localStorage 中的列数与当前 sourceData 的列数是否一致
      if (order.length !== this.sourceData.length) {
        // 列数不一致，删除旧的 localStorage 数据并重新创建
        //console.log('列数不一致，重置列排序。原列数:', order.length, '现列数:', this.sourceData.length);
        localStorage.removeItem('sourceOrder');
        order = this.sourceData.map(function (item) {
          return item.idx;
        });
        localStorage.setItem('sourceOrder', JSON.stringify(order));
      }
      // 根据更新后的 order 重新排序 sourceData
      this.sourceData = order.map(function (idx) {
        return _this2.sourceData.find(function (item) {
          return item.idx === idx;
        });
      }).filter(function (item) {
        return item !== undefined;
      });
    } else {
      // 如果没有 order，则生成默认顺序并存储
      order = this.sourceData.map(function (item) {
        return item.idx;
      });
      localStorage.setItem('sourceOrder', JSON.stringify(order));
    }
    // this.handleSearch();
  },
  watch: {
    // 监视 checkedItems 数组的变化，更新 selectAll 状态
    checkedItems: {
      handler: function handler() {
        this.selectAll = this.checkedItems.every(function (item) {
          return item;
        });
      },
      deep: true
    },
    multipleSelection: {
      handler: function handler(val) {
        if (val.length === 1) {
          this.printFlag = !!val.some(function (item) {
            return item.pol === 'MYWSP' || item.pol === 'MYPKG' || item.pol === 'MYKUA' || item.pol === 'MYPGU' || item.pol === 'MYPEN';
          });
        } else {
          this.printFlag = false;
        }
      },
      deep: true
    },
    selectList: {
      handler: function handler(val) {
        if (val.length === 1) {
          this.printFlag = !!val.some(function (item) {
            return item.pol === 'MYWSP' || item.pol === 'MYPKG' || item.pol === 'MYKUA' || item.pol === 'MYPGU' || item.pol === 'MYPEN';
          });
        } else {
          this.printFlag = false;
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      // this.tableData = [{id:1,bookingNo:'123456',blNo:'123456',pol:'CNHKG',pod:'JPTYO',vesselName:'COSCO',voyageNo:'123456',status:'1',},]
      // this.resizeHotTable()
    });
    this.isShow = this.userInfo.bookingViewType;
    this.handleInitTime();
    this.handleSearch();
  },
  methods: {
    initData: function initData() {
      var _this3 = this;
      this.sourceData = [{
        idx: 1,
        sortable: true,
        showOverflowTooltip: true,
        width: "150",
        label: this.$t('home.bookingStatus'),
        prop: "status",
        title: this.$t('home.bookingStatus'),
        data: "status"
      }, {
        idx: 2,
        sortable: true,
        showOverflowTooltip: true,
        width: "150",
        label: this.$t('home.bkNo'),
        prop: "bkNo",
        title: this.$t('home.bkNo'),
        data: "bkNo"
      }, {
        idx: 3,
        sortable: true,
        showOverflowTooltip: true,
        width: "160",
        label: this.$t('home.blNo'),
        prop: "blNo",
        title: this.$t('home.blNo'),
        data: "blNo"
      }, {
        idx: 4,
        sortable: true,
        showOverflowTooltip: false,
        width: "180",
        label: this.$t('home.portOfDeparture'),
        prop: "portOfDeparture",
        title: this.$t('home.portOfDepartureBySort'),
        data: "portOfDeparture"
      }, {
        idx: 5,
        sortable: true,
        showOverflowTooltip: true,
        width: "140",
        label: this.$t('home.vesselName'),
        prop: "vesselName",
        title: this.$t('home.vesselName'),
        data: "vesselName"
      }, {
        idx: 6,
        sortable: true,
        showOverflowTooltip: false,
        width: "110",
        label: this.$t('home.voyageNo'),
        prop: "voyageNo",
        title: this.$t('home.voyageNo'),
        data: "voyageNo"
      }, {
        idx: 7,
        sortable: true,
        showOverflowTooltip: false,
        width: "100",
        label: this.$t('home.route'),
        prop: "serviceLineCode",
        title: this.$t('home.route'),
        data: "serviceLineCode"
      }, {
        idx: 8,
        sortable: true,
        showOverflowTooltip: true,
        width: "130",
        label: "CY Cut Time",
        prop: "cutOffTime",
        title: "CY Cut Time",
        data: "cutOffTime"
      }, {
        idx: 9,
        sortable: true,
        showOverflowTooltip: false,
        width: "180",
        label: this.$t('home.bookEta'),
        prop: "latestEtdPol",
        title: this.$t('home.bookEta'),
        data: "latestEtdPol"
      }, {
        idx: 10,
        sortable: true,
        showOverflowTooltip: false,
        width: "180",
        label: this.$t('home.bookEtd'),
        prop: "etdLatest",
        title: this.$t('home.bookEtd'),
        data: "etdLatest"
      }, {
        idx: 11,
        sortable: true,
        showOverflowTooltip: false,
        width: "180",
        label: this.$t('home.bookAtd'),
        prop: "eta",
        title: this.$t('home.bookAtd'),
        data: "eta"
      }, {
        idx: 12,
        sortable: true,
        showOverflowTooltip: false,
        width: "100",
        label: this.$t('home.del'),
        prop: "del",
        title: this.$t('home.del'),
        data: "del"
      }, {
        idx: 13,
        sortable: true,
        showOverflowTooltip: true,
        width: "120",
        label: "VGM",
        prop: "vgm",
        title: "VGM",
        data: "vgm"
      }, {
        idx: 14,
        sortable: true,
        showOverflowTooltip: false,
        width: "140",
        label: this.$t('home.editTime'),
        prop: "updateTime",
        title: this.$t('home.editTime'),
        data: "updateTime"
      }, {
        idx: 15,
        sortable: true,
        showOverflowTooltip: false,
        width: "140",
        label: this.$t('home.createTime'),
        prop: "createTime",
        title: this.$t('home.createTime'),
        data: "createTime"
      }, {
        idx: 16,
        sortable: true,
        showOverflowTooltip: false,
        width: "130",
        label: this.$t('home.manifestType'),
        prop: "bookingType2",
        title: this.$t('home.manifestType'),
        data: "bookingType2"
      }, {
        idx: 17,
        sortable: true,
        showOverflowTooltip: false,
        width: "130",
        label: this.$t('home.blNoTypeOne'),
        prop: "blType",
        title: this.$t('home.blNoTypeOne'),
        data: "blType"
      }, {
        idx: 18,
        sortable: true,
        showOverflowTooltip: true,
        width: "130",
        label: this.$t('home.topBl'),
        prop: "topBl",
        title: this.$t('home.topBl'),
        data: "topBl"
      }, {
        idx: 19,
        sortable: true,
        showOverflowTooltip: true,
        width: "200",
        label: this.$t('home.containerVolume'),
        prop: "crnt",
        title: this.$t('home.containerVolume'),
        data: "crnt"
      }, {
        idx: 20,
        sortable: true,
        showOverflowTooltip: false,
        width: "100",
        label: this.$t('home.transfer'),
        prop: "tsFlag",
        title: this.$t('home.transfer'),
        data: "tsFlag"
      }, {
        idx: 21,
        sortable: true,
        showOverflowTooltip: false,
        width: "120",
        label: this.$t('home.temperature'),
        prop: "temperature",
        title: this.$t('home.temperature'),
        data: "temperature"
      }, {
        idx: 22,
        sortable: true,
        showOverflowTooltip: true,
        width: "100",
        label: this.$t('home.dgCheckFlagOne'),
        prop: "dginfo",
        title: this.$t('home.dgCheckFlagOne'),
        data: "dginfo"
      }, {
        idx: 23,
        sortable: true,
        showOverflowTooltip: true,
        width: "100",
        label: this.$t('home.remark'),
        prop: "remark",
        title: this.$t('home.remark'),
        data: "remark"
      }, {
        idx: 24,
        sortable: true,
        showOverflowTooltip: true,
        width: "180",
        label: this.$t('home.agreementNo'),
        prop: "agreementNo",
        title: this.$t('home.agreementNo'),
        data: "agreementNo"
      }, {
        idx: 25,
        sortable: true,
        showOverflowTooltip: true,
        width: "180",
        label: this.$t('home.ft'),
        prop: "freeTimeNo",
        title: this.$t('home.ft'),
        data: "freeTimeNo"
      }];
      this.targetDataOne = [];
      this.tableKey += 1;
      this.$refs.transfer && this.$refs.transfer.initData(this.sourceData, this.targetDataOne);
      this.$nextTick(function () {
        _this3.handleSearch();
      });
    },
    handleSubmitSort: function handleSubmitSort(data) {
      this.transferDialogVisible = false;
      this.sourceData = data;
      this.tableKey += 1;
      //this.handleSearch()
    },
    handleSortOpen: function handleSortOpen() {
      console.log('this.sourceData', this.sourceData);
      this.transferDialogVisible = true;
    },
    handleImport: function handleImport() {
      this.importDialog = true;
    },
    handleExportExcel: function handleExportExcel() {
      var _this4 = this;
      if (this.tableData.length > 0) {
        var data = this.setTime();
        data.status ? data.status = data.status.join(',') : '';
        this.loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        (0, _booking.exportBookingHistory)(data).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/x-execl'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          _this4.language === 'en' ? link.setAttribute('download', 'My Booking' + '.xlsx') : link.setAttribute('download', '我的订舱' + '.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this4.loading.close();
        });
      } else {
        this.$message.warning(this.$t('home.exportMessage'));
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.listQuery.currentPage - 1) * this.listQuery.pageSize + index + 1;
    },
    tableRowClassName: function tableRowClassName(_ref3) {
      var row = _ref3.row,
        rowIndex = _ref3.rowIndex;
      // console.log(row,'row0000')
      if (row.webCntFlag === '1') {
        if (this.selectedRows.includes(row)) {
          console.log('我是布料');
          return 'select-special-row';
        }
        return 'special-row';
      }
      if (this.selectedRows.includes(row)) {
        console.log('我是普通');
        return 'select-common-row';
      }
      return 'common-row';
    },
    handleSearchSelect: function handleSearchSelect() {
      this.listQuery.currentPage = 1;
      this.handleSearch();
    },
    handOpenPrint: function handOpenPrint(row) {
      var _this5 = this;
      if (row.pol.startsWith('KR')) {
        this.viewVisible = true;
        this.viewMainId = row.bookingHeadWebComId;
      } else {
        this.loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        (0, _booking.getUrlStrForPreview)(row.bookingHeadWebComId).then(function (res) {
          if (res.success) {
            window.open(res.data);
          }
        }).finally(function () {
          _this5.loading.close();
        });
      }
    },
    // 打印
    handlePrint: function handlePrint(id) {
      var _this6 = this;
      var data = null;
      this.isShow ? data = this.multipleSelection : data = this.selectList;
      // console.log(this.multipleSelection,'this.multipleSelection')
      if (!this.justSelectOne(data)) {
        return;
      }
      var dataOne = data[0];
      if (dataOne.pol === 'CNSHA' && dataOne.status == 3 || dataOne.status == 10) {
        this.$message.error(this.$t('home.statusPrintMessage'));
        return false;
      }
      if (dataOne.pol.startsWith('KR')) {
        this.viewVisible = true;
        this.viewMainId = dataOne.bookingHeadWebComId;
        return;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _booking.getUrlStrForPreview)(dataOne.bookingHeadWebComId).then(function (res) {
        if (res.success) {
          window.open(res.data);
        }
      }).finally(function () {
        _this6.loading.close();
      });
    },
    saveCancelBookingHeadWebCom: function saveCancelBookingHeadWebCom(id) {
      var _this7 = this;
      this.$confirm(this.$t('home.cancelBookingConfirmMsg'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('confirmMsg.confirm'),
        cancelButtonText: this.$t('confirmMsg.close'),
        type: 'warning'
      }).then(function (_) {
        _this7.loading = _this7.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        (0, _booking.saveCancelBookingHeadWebCom)(id).then(function (res) {
          if (res.success) {
            if (res.data) {
              _this7.$message.error(res.data);
              _this7.loading.close();
            } else {
              _this7.$message.success(_this7.$t('home.cancelBookingMessage'));
              _this7.handleSearch();
              _this7.loading.close();
            }
          } else {
            _this7.$message.error(res.errorMessages[0]);
            _this7.loading.close();
          }
        }).finally(function () {
          _this7.loading.close();
        });
      }).catch(function (_) {});
    },
    saveCancelBookingHeadWebComList: function () {
      var _saveCancelBookingHeadWebComList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this8 = this;
        var dataArray, isSelected, cancelBookingHeadWebIdList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dataArray = [];
              isSelected = false;
              if (this.isShow) {
                isSelected = this.handleValistLength(this.multipleSelection);
                dataArray = this.multipleSelection;
              } else {
                isSelected = this.handleValistLength(this.selectList);
                dataArray = this.selectList;
              }
              if (isSelected) {
                cancelBookingHeadWebIdList = dataArray.map(function (item) {
                  return item.bookingHeadWebComId;
                }).join(',');
                this.cancelBookingListMsg = '';
                this.$confirm(this.$t('home.cancelBookingConfirmMsg'), this.$t('confirmMsg.title'), {
                  confirmButtonText: this.$t('confirmMsg.confirm'),
                  cancelButtonText: this.$t('confirmMsg.close'),
                  type: 'warning'
                }).then(function (_) {
                  _this8.loading = _this8.$loading({
                    lock: true,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  (0, _booking.saveCancelBookingHeadWebCom)(cancelBookingHeadWebIdList).then(function (res) {
                    if (res.success) {
                      if (res.data) {
                        _this8.cancelBookingListMsg = res.data;
                        _this8.cancelBookingListMsgVisible = true;
                      } else {
                        _this8.$message.success(_this8.$t('home.cancelBookingMessage'));
                        _this8.handleSearch();
                      }
                    } else {
                      _this8.$message.error(res.errorMessages[0]);
                    }
                  }).finally(function (_) {
                    _this8.loading.close();
                  });
                }).catch(function (error) {
                  _this8.loading.close();
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function saveCancelBookingHeadWebComList() {
        return _saveCancelBookingHeadWebComList.apply(this, arguments);
      }
      return saveCancelBookingHeadWebComList;
    }(),
    handleBookMaterialsDetailVerify: function handleBookMaterialsDetailVerify(item) {
      if (item.webCntFlag == '0') {
        this.$message.warning(this.$t('home.detailVerifyMessage'));
        return false;
      }
      this.$router.push({
        path: '/bookingSpace/bookMaterialsDetailVerify',
        query: {
          id: item.bookingHeadWebComId
        }
      });
    },
    // 订舱撤回
    saveWithdrawBookingHeadWebCom: function saveWithdrawBookingHeadWebCom(id) {
      var _this9 = this;
      this.$confirm(this.$t('home.revocationConfirmMessage'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('confirmMsg.confirm'),
        cancelButtonText: this.$t('confirmMsg.close'),
        type: 'warning'
      }).then(function (_) {
        _this9.loading = _this9.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        (0, _booking.saveWithdrawBookingHeadWebCom)(id).then(function (res) {
          if (res.success) {
            _this9.$message.success(_this9.$t('home.revocationMessage'));
            _this9.handleSearch();
          } else {
            _this9.$message.error(res.errorMessages[0]);
          }
        }).finally(function () {
          _this9.loading.close();
        });
      }).catch(function (error) {
        _this9.loading.close();
      });
    },
    // 判断是否可以进行F/T申请
    handleGoToFt: function handleGoToFt(item) {
      console.log(item, 'item', item.pol);
      if (item.pol.startsWith('VN')) {
        this.$message.warning(this.$t('home.ftapplyMessageValid'));
        return false;
      }
      if (item.cntFlag == '0') {
        this.$message.warning(this.$t('home.ftapplyMessageValidOne'));
        return false;
      }
      return true;
    },
    dropdownItemClick: function dropdownItemClick(item, index) {
      if (index == 2) {
        if (!this.handleGoToFt(item)) {
          return false;
        }
        this.handleOpenFt(item);
      } else if (index == 3) {
        this.handleExport(item);
      } else if (index == 9) {
        this.saveWithdrawBookingHeadWebCom(item.bookingHeadWebComId);
      } else if (index === 0) {
        this.$router.push({
          path: '/bookingSpace/bookingSpaceDetail',
          query: {
            id: item.bookingHeadWebComId,
            type: 'copy'
          }
        });
      } else if (index === 1) {
        this.handleCopyTwo(item);
      } else if (index === 4) {
        this.saveCancelBookingHeadWebCom(item.bookingHeadWebComId);
      } else if (index === 5) {
        this.handleOpenNewReport(item, 0, 0);
      } else if (index === 6) {
        this.handleOpenNewReport(item, 1, 0);
      } else if (index === 7) {
        this.handleOpenNewReport(item, 3, 0);
      }
      // else if(index===8){
      //   // 拆单补料
      //   this.handleOpenNewReport(item,0,1)
      // }
      else if (index === 8) {
        this.handleBookMaterialsDetailVerify(item);
      } else if (index === 10) {
        this.handOpenPrint(item);
      } else if (index === 11) {
        this.handOpenPrintSo(item);
      }
    },
    shouldShowItem: function shouldShowItem(item, index) {
      // console.log(item,'item',index)
      if (index == 10) {
        return this.showView(item);
      }
      if (index == 11) {
        return this.showViewSo(item);
      }
      if (index !== 10 && index !== 10) {
        return true;
      }
    },
    handleCopyOne: function handleCopyOne(item) {
      this.$router.push({
        path: '/bookingSpace/bookingSpaceDetail',
        query: {
          id: item.bookingHeadWebComId,
          type: 'copy'
        }
      });
    },
    handleCopyTwo: function handleCopyTwo(item) {
      var _this10 = this;
      console.log(item, 'item');
      var data = {
        vesselCode: item.vesselCode,
        voyageNo: item.voyageNo,
        voyageLeg: item.voyageLeg,
        portCode: item.pol
      };
      this.loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _booking.getLockByDoc)(data).then(function (res) {
        if (res.success) {
          if (res.data) {
            _this10.$message.warning(_this10.$t('home.getLockByDocMessage'));
          } else {
            _this10.copyId = item.bookingHeadWebComId;
            _this10.polCopy = item.pol;
            _this10.copyVisible = true;
          }
        }
      }).finally(function () {
        _this10.loading.close();
      });
    },
    parseTime: _utils.parseTime,
    handleOpenVesselSearch: function handleOpenVesselSearch() {
      this.sailScheduleDialogType = 'search';
      this.sailScheduleDialogVisible = true;
    },
    handleCommand: function handleCommand(command) {
      this.$message('click on item ' + command);
    },
    // 申请F/T
    handleOpenFt: function handleOpenFt(item) {
      // || 'SITTAGVT722199'
      if (!this.handleGoToFt(item)) {
        return false;
      }
      this.pol = item.pol;
      this.blNo = item.blNo;
      this.ftDialogVisible = true;
    },
    // 拆单补料
    handleOpenNewReportTable: function handleOpenNewReportTable() {
      var dataArray = [];
      var isSelectOne = false;
      if (this.isShow) {
        isSelectOne = this.justSelectOne(this.multipleSelection);
        dataArray = this.multipleSelection[0];
      } else {
        isSelectOne = this.justSelectOne(this.selectList);
        dataArray = this.selectList[0];
      }
      isSelectOne && this.handleOpenNewReport(dataArray, 0, 1);
    },
    // 分报合出
    handleOpenNewReport: function handleOpenNewReport(item, type, confirmFlag) {
      console.log('item', item);
      console.log('item.status,item.bookingType2,item.blType,item.separateType,type', item.status, item.bookingType2, item.blType, item.separateType, type);
      console.log('item.bookingType2,  item.blType,item.separateType ', item.bookingType2, item.blType, item.separateType);
      if (!item.blNo) {
        this.$message({
          message: this.$t('home.blNoRequire2'),
          type: 'warning'
        });
        return;
      }
      if (confirmFlag === 0) {
        if (item.status === 1 || item.status === 15 || item.status === 19 || item.status === 21 || item.status === 17 || item.status === 5) {
          console.log('校验');
          console.log('校验拆单并单');
          if (type === 0 && item.blType == '1') {
            this.$message({
              message: this.$t('home.splistWanning'),
              type: 'warning'
            });
            return;
          } else if (type === 3 && item.blType == '1') {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanningType3'),
              type: 'warning'
            });
            return;
          } else if (type === 1 && item.blType == '0') {
            this.$message({
              message: this.$t('home.splistWanning'),
              type: 'warning'
            });
            return;
          } else if (type === 3 && item.blType == '0') {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanningType3'),
              type: 'warning'
            });
            return;
          } else if (item.topBl !== "" && item.topBl !== null) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanning6'),
              type: 'warning'
            });
            return;
          } else if (item.separateType == '1' && (item.status !== 17 && item.status !== 1 && item.status !== 5 && type === 3 || type !== 3)) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanning5'),
              type: 'warning'
            });
            return;
          } else if (item.separateType == '2' && item.status !== 1 && item.status !== 5) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanning4'),
              type: 'warning'
            });
            return;
          } else if (item.separateType == '2' && (item.status == 1 || item.status == 5) && type === 3) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanning3'),
              type: 'warning'
            });
            return;
          } else if ((item.bookingType2 !== '4' || item.blType !== '2') && item.separateType !== '1' && type === 3) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanningBooking'),
              type: 'warning'
            });
            return;
          } else if ((item.bookingType2 !== '4' || item.blType !== '2') && (item.bookingType2 !== '1' || item.blType !== '1') && type === 1) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanningBooking1'),
              type: 'warning'
            });
            return;
          }

          // 舱单类型：bookingType2  提单类型：blType
          else {
            this.newReportSearchForm.id = item.bookingHeadWebComId;
            this.newReportSearchForm.spliteCombinType = type;
            this.newReportSearchForm.confirmFlag = confirmFlag;
            this.newReportData = item;
            this.newReportsDialogVisible = true;
          }
        } else {
          console.log('不校验');
          if (type === 0) {
            this.$message({
              message: this.$t('home.reportOutWarning'),
              type: 'warning'
            });
          } else if (type === 1) {
            this.$message({
              message: this.$t('home.reportOutOneWarning'),
              type: 'warning'
            });
          } else if (type === 3) {
            this.$message({
              message: this.$t('home.reportOutTwoWarning'),
              type: 'warning'
            });
          }
          return;
        }
      } else {
        if (item.pol !== 'CNSHK' && item.pol !== 'CNNSA' && item.pol !== 'CNTAG' && !item.pol.startsWith('TH') && (type === 0 || type === 1)) {
          this.$message({
            message: this.$t('booking.bookingSplit.splistCNSHA'),
            type: 'warning'
          });
          return;
        }
        if (item.status === 1 || item.status === 15 || item.status === 19 || item.status === 21 || item.status === 17 || item.status === 5) {
          //
          // if ((type === 1 || type === 3) && item.blType == '0') {
          //    this.$message({
          //      message: this.$t('booking.bookingSplit.splistWanning10'),
          //      type: 'warning'
          //    })
          //    return
          //  }
          if (item.topBl !== "" && item.topBl !== null && type === 0) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistChildrenWarning0'),
              type: 'warning'
            });
            return;
          } else if (item.topBl !== "" && item.topBl !== null && type === 1) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistChildrenWarning1'),
              type: 'warning'
            });
            return;
          } else if (item.separateType == '2' && item.status !== 1 && item.status !== 5) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistWanning4'),
              type: 'warning'
            });
            return;
          } else if ((item.status !== 1 || item.status !== 5 || item.status !== 19) && item.cntFlag !== '0' && type === 0) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistCntFlag'),
              type: 'warning'
            });
            return;
          } else if ((item.status !== 1 || item.status !== 5 || item.status !== 19) && item.cntFlag !== '0' && type === 1) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistCntFlag2'),
              type: 'warning'
            });
            return;
          } else if ((item.bookingType2 !== '1' || item.blType !== '0') && item.blType !== '2' && type === 0) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistMain1'),
              type: 'warning'
            });
            return;
          } else if ((item.bookingType2 !== '1' || item.blType !== '1') && item.blType !== '2' && type === 1) {
            this.$message({
              message: this.$t('booking.bookingSplit.splistMain2'),
              type: 'warning'
            });
            return;
          }
          // 舱单类型：bookingType2  提单类型：blType
          else {
            this.newReportSearchForm.id = item.bookingHeadWebComId;
            this.newReportSearchForm.spliteCombinType = type;
            this.newReportSearchForm.confirmFlag = confirmFlag;
            this.newReportData = item;
            this.newReportsDialogVisible = true;
          }
        } else {
          console.log('不校验');
          if (confirmFlag === 0) {
            if (type === 0) {
              this.$message({
                message: this.$t('booking.bookingSplit.splitWarningOut1'),
                type: 'warning'
              });
              return;
            } else if (type === 1) {
              this.$message({
                message: this.$t('booking.bookingSplit.splitWarningOut2'),
                type: 'warning'
              });
              return;
            } else if (type === 3) {
              this.$message({
                message: this.$t('home.reportOutTwoWarning'),
                type: 'warning'
              });
              return;
            }
          } else {
            if (type === 0) {
              this.$message({
                message: this.$t('booking.bookingSplit.reportOutWarning'),
                type: 'warning'
              });
              return;
            } else if (type === 1) {
              this.$message({
                message: this.$t('booking.bookingSplit.reportOutOneWarning'),
                type: 'warning'
              });
              return;
            }
          }
        }
      }
    },
    // 申请F/T导出
    handleExport: function handleExport(item) {
      var _this11 = this;
      this.loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      console.log(item, 'item');
      (0, _booking.getUrlForFreeTime)(item.blNo).then(function (res) {
        if (res.success) {
          window.open(res.data);
        }
      }).finally(function () {
        _this11.loading.close();
      });
    },
    handleClose: function handleClose() {
      this.newReportsDialogVisible = false;
    },
    handleGetTable: function handleGetTable() {
      this.newReportsDialogVisible = false;
      this.combinDialogDialog = false;
      this.handleSearchSelect();
    },
    handleImportVgm: function handleImportVgm() {
      if (this.selectedRows.some(function (item) {
        return item.status !== 1 && item.status !== 5;
      })) {
        this.$message.warning(this.$t('home.bookSureCanUse'));
      } else {
        this.vgmImportDialogVisible = true;
      }
    },
    handleOpenCheck: function handleOpenCheck() {
      this.$refs.checkDialog.checkDialogVisible = true;
    },
    // 导入格式下载
    handleDownloadExcel: function handleDownloadExcel() {
      var link = document.createElement('a');
      link.href = '/static/excel/Container&VGM_Import_Format.xls'; // 指向你的 Word 文档路径
      link.download = 'Container&VGM_Import_Format.xls'; // 设置下载文件名
      link.click(); // 触发点击事件
    },
    handleDownloadExcelKR: function handleDownloadExcelKR() {
      var link = document.createElement('a');
      link.href = '/static/excel/Document_Import_Format.xls'; // 指向你的 Word 文档路径
      link.download = 'Document_Import_Format.xls'; // 设置下载文件名
      link.click(); // 触发点击事件
    },
    uploadFile: function uploadFile(item) {
      var _this12 = this;
      this.loading = true;
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      (0, _booking.excelImportDocument)(formDatas).then(function (res) {
        if (res.success) {
          _this12.$message.success(_this12.$t("com.importSuccess"));
          _this12.handleSearch();
        } else {
          _this12.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this12.loading = false;
        console.log("-----zzz");
        _this12.fileList = [];
        _this12.$refs.upload.clearFiles();
      });
    },
    handleSelectAllChange: function handleSelectAllChange(val) {
      // 更新所有复选框的选中状态
      this.checkedItems = this.checkedItems.map(function () {
        return val;
      });
      this.selectList = this.tableData;
    },
    handleCheckboxChange: function handleCheckboxChange(index, event) {
      var _this13 = this;
      console.log("\u7B2C ".concat(index, " \u4E2A\u590D\u9009\u6846\u72B6\u6001\u66F4\u6539\u4E3A:"), event.target);
      this.selectList = this.tableData.filter(function (item, idx) {
        return _this13.checkedItems[idx];
      });
      console.log(this.selectList);

      // 在这里执行其他操作
    },
    changeTime: function changeTime(val) {
      console.log(val, '时间的惦2222');
      this.currentFlag = val;
      if (val === '1') {
        var date1 = (0, _date.dateFormat)('YYYY-MM-DD', new Date() - 14 * 24 * 60 * 60 * 1000);
        var date2 = (0, _date.dateFormat)('YYYY-MM-DD', new Date());
        this.dataTime = [date1, date2];
      } else {
        this.dataTime = [this.listQuery.createdFrom, this.listQuery.createdTo];
      }
      // this.caculateTime(val)
    },
    handleChangeTime: function handleChangeTime() {
      console.log(this.dataTime, '时间的惦999');
      if (!this.dataTime) {
        this.handleChangeTimeClear();
        return;
      }
      if (this.currentFlag === '1') {
        this.listQuery.etd = this.dataTime[0];
        this.listQuery.etdTo = this.dataTime[1];
      } else {
        this.listQuery.createdFrom = this.dataTime[0];
        this.listQuery.createdTo = this.dataTime[1];
      }
    },
    handleChangeTimeClear: function handleChangeTimeClear() {
      this.listQuery.etd = '';
      this.listQuery.etdTo = '';
      this.listQuery.createdFrom = '';
      this.listQuery.createdTo = '';
      console.log(this.listQuery, '00000listQuery');
    },
    handleInitTime: function handleInitTime() {
      this.listQuery.etd = this.caculateTime(this.listQuery.etd, 1);
      this.listQuery.etdTo = this.caculateTime(this.listQuery.etdTo, 2);
      this.listQuery.createdFrom = this.caculateTime(this.listQuery.createdFrom, 1);
      this.listQuery.createdTo = this.caculateTime(this.listQuery.createdTo, 2);
      var date1 = (0, _date.dateFormat)('YYYY-MM-DD', new Date() - 14 * 24 * 60 * 60 * 1000);
      var date2 = (0, _date.dateFormat)('YYYY-MM-DD', new Date());
      this.dataTime = [date1, date2];
      // console.log(this.dataTime,'时间的惦')
    },
    caculateTime: function caculateTime(time, val) {
      var mapObject = {
        1: -2,
        2: 40,
        3: -7,
        4: 31
      };
      var day = mapObject[val];
      var timestamp = '';
      console.log(time, 'time8888');
      time ? timestamp = time.getTime() : timestamp = new Date().getTime();
      var oneDay = 24 * 60 * 60 * 1000;
      var newTimestamp = timestamp + day * oneDay;
      // console.log(timestamp,'timestamp',day * oneDay)
      // console.log(new Date(newTimestamp),time,'两周后的时间',day);
      return new Date(newTimestamp);
    },
    // 当前行复选框被选中时
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      // val是数组
      // this.listQuery.vesselCode = val.vesselCode
      // this.listQuery.vesselName = val.vesselName
      // this.listQuery.voyageLeg = val.voyageLeg
      // this.listQuery.voyageNo = val.voyageNo
      // 选中的数组
      this.selectedRows = val;
    },
    handleGoApply: function handleGoApply() {
      if (this.multipleSelection.length > 0) {
        var data = this.multipleSelection[0];
        this.object = {
          vesselCode: data.vesselCode,
          vesselName: data.vesselName,
          voyageNo: data.voyageNo,
          voyageLeg: data.voyageLeg,
          blNo: this.multipleSelection.length >= 2 ? null : data.blNo
        };
      }
      console.log(' this.object', this.object);
      this.$router.push({
        path: '/bookingSpace/releaseApply',
        query: {
          releaseParams: JSON.stringify(this.object)
        }
      });
    },
    handleGoCutTime: function handleGoCutTime() {
      if (this.multipleSelection.length === 1) {
        var data = this.multipleSelection[0];
        var object = {
          vesselCode: data.vesselCode,
          vesselName: data.vesselName,
          voyageNo: data.voyageNo,
          voyageLeg: data.voyageLeg
        };
        this.$router.push({
          path: '/bookingSpace/cutTime',
          query: {
            cutTimeVessel: JSON.stringify(object)
          }
        });
      } else if (this.multipleSelection.length === 0) {
        this.$router.push({
          path: '/bookingSpace/cutTime'
        });
      } else {
        this.$message.warning(this.$t('home.onlyOneOrNullWarning'));
        return false;
      }
    },
    handleShow: function handleShow() {
      this.multipleSelection = [];
      this.selectList = [];
      this.printFlag = false;
      this.isShow = !this.isShow;
    },
    handleAddBookingSubmit: function handleAddBookingSubmit(row) {
      var _this14 = this;
      if (row.status !== 10) {
        this.$message.warning(this.$t('home.statusMessage'));
        return;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _booking.saveOrUpdateAmendBkWebCom)(row.bookingHeadWebComId).then(function (res) {
        if (res.success) {
          _this14.$message.success(_this14.$t('home.submitSuccess'));
          _this14.handleSearch();
        }
      }).finally(function () {
        _this14.loading.close();
      });
    },
    // 批量提交
    handleBatchCommit: function handleBatchCommit() {
      var _this15 = this;
      var dataArray = [];
      var isSelected = false;
      if (this.isShow) {
        isSelected = this.handleValistLength(this.multipleSelection);
        dataArray = this.multipleSelection;
      } else {
        isSelected = this.handleValistLength(this.selectList);
        dataArray = this.selectList;
      }
      if (isSelected) {
        var data = dataArray.map(function (item) {
          return item.bookingHeadWebComId;
        });
        (0, _booking.batchCommit)(data).then(function (res) {
          if (res.success) {
            if (res.data) {
              _this15.$confirm(res.data.replace(/\n/g, '<br>'), _this15.$t('confirmMsg.title'), {
                confirmButtonText: _this15.$t('confirmMsg.close'),
                type: 'warning',
                showCancelButton: false,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true
              }).then(function () {
                _this15.handleSearch();
              });
            } else {
              _this15.$message.success(_this15.$t('home.submitSuccess'));
              _this15.handleSearch();
            }
          }
        });
      }
    },
    handleLook: function () {
      var _handleLook = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(data) {
        var status;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              status = data.status;
              if (status == 10 || status == 11 || status == 0 || status == 1 || status == 8 || status == 9 || status == 5) {
                this.$router.push({
                  path: '/bookingSpace/bookingSpaceDetail',
                  query: {
                    id: data.bookingHeadWebComId,
                    type: 'Edit'
                  }
                });
              } else if (status == 3 || status == 4 || status == 19 || status == 20 || status == 21 || status == 22 || status == 17 || status == 18) {
                this.$router.push({
                  path: '/bookingSpace/bookingSpaceDetail',
                  query: {
                    id: data.bookingHeadWebComId,
                    type: 'Look'
                  }
                });
              } else {
                this.$message.warning(this.$t('home.statusMessage'));
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleLook(_x) {
        return _handleLook.apply(this, arguments);
      }
      return handleLook;
    }(),
    handleLookSupply: function () {
      var _handleLookSupply = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(data) {
        var valid, status;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getLookOneSupplyFlag(data);
            case 2:
              valid = _context3.sent;
              status = data.status;
              if (!valid) {
                _context3.next = 7;
                break;
              }
              this.$message.warning(valid);
              return _context3.abrupt("return");
            case 7:
              if (status == 1 || status == 14 || status == 13 || status == 5) {
                this.$router.push({
                  path: '/bookingSpace/bookMaterialsDetail',
                  query: {
                    id: data.bookingHeadWebComId,
                    type: 'Edit'
                  }
                });
              } else if (status == 4 || status == 9 || status == 3 || status == 8 || status == 19 || status == 20 || status == 21 || status == 22 || status == 17 || status == 18) {
                this.$router.push({
                  path: '/bookingSpace/bookMaterialsDetail',
                  query: {
                    id: data.bookingHeadWebComId,
                    type: 'Look'
                  }
                });
              } else {
                this.$message.warning(this.$t('home.statusMessage'));
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleLookSupply(_x2) {
        return _handleLookSupply.apply(this, arguments);
      }
      return handleLookSupply;
    }(),
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      this.listQuery.vesselCode = row.vesselCode;
      this.listQuery.vesselName = row.vesselName;
      this.listQuery.voyageLeg = row.voyageLeg;
      this.listQuery.voyageNo = row.voyageNo;
    },
    handleValistLength: function handleValistLength(data) {
      if (data.length < 1) {
        this.$message.warning(this.$t('home.warning'));
        return false;
      }
      return true;
    },
    // 船名航次调整
    handleAdjustVessel: function () {
      var _handleAdjustVessel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var dataArray, isSelectOne, cancelFlag, validateBkLockRes, validateVoyageAdjustRes;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              dataArray = [];
              isSelectOne = false;
              if (this.isShow) {
                isSelectOne = this.handleValistLength(this.multipleSelection);
                dataArray = this.multipleSelection;
              } else {
                isSelectOne = this.handleValistLength(this.selectList);
                dataArray = this.selectList;
              }
              if (!isSelectOne) {
                _context4.next = 24;
                break;
              }
              cancelFlag = dataArray.some(function (item, index, array) {
                return item.status === '3' || item.status === 3;
              });
              if (!cancelFlag) {
                _context4.next = 8;
                break;
              }
              this.$message.warning(this.$t('home.cancelBookingChangeVVLMessage'));
              return _context4.abrupt("return");
            case 8:
              this.bookingHeadWebId = dataArray.map(function (item) {
                return item.bookingHeadWebComId;
              }).join(',');
              _context4.next = 11;
              return (0, _booking.validateBkLock)(Object.assign({}, {
                bookingHeadWebIds: this.bookingHeadWebId
              }));
            case 11:
              validateBkLockRes = _context4.sent;
              if (!validateBkLockRes.data) {
                _context4.next = 16;
                break;
              }
              this.adVesselMsg = validateBkLockRes.data;
              this.adjustVesselMsgVisible = true;
              return _context4.abrupt("return");
            case 16:
              _context4.next = 18;
              return (0, _booking.validateVoyageAdjust)(Object.assign({}, {
                bookingHeadWebIds: this.bookingHeadWebId
              }));
            case 18:
              validateVoyageAdjustRes = _context4.sent;
              if (!validateVoyageAdjustRes.data) {
                _context4.next = 23;
                break;
              }
              this.adVesselMsg = validateVoyageAdjustRes.data;
              this.adjustVesselMsgVisible = true;
              return _context4.abrupt("return");
            case 23:
              this.vesselVoyageDialogVisible = true;
            case 24:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleAdjustVessel() {
        return _handleAdjustVessel.apply(this, arguments);
      }
      return handleAdjustVessel;
    }(),
    // 并单取消
    handleOpenCancel: function handleOpenCancel() {
      var _this16 = this;
      var dataArray = [];
      var isSelectOne = false;
      if (this.isShow) {
        console.log(this.multipleSelection, 'this.multipleSelection');
        isSelectOne = this.justSelectOne(this.multipleSelection);
        dataArray = this.multipleSelection[0];
      } else {
        console.log(this.selectList, 'this.selectList');
        isSelectOne = this.justSelectOne(this.selectList);
        dataArray = this.selectList[0];
      }
      if (dataArray.pol !== 'CNSHk' && dataArray.pol !== 'CNNSA' && dataArray.pol !== 'CNTAG' && !dataArray.pol.startsWith('TH')) {
        this.$message.error(this.$t('home.statusCancelMessage'));
        return false;
      }
      if (isSelectOne) {
        if (dataArray.bookingType2 === '1' && dataArray.blType === '1') {
          var data = {
            spliteCombinType: 1,
            id: dataArray.bookingHeadWebComId
          };
          (0, _newReports.cancelSpliteData)(data).then(function (res) {
            _this16.$message({
              message: _this16.$t('home.cancelSuccess'),
              type: 'success'
            });
            _this16.handleSearch();
          });
        } else {
          this.$message.warning(this.$t('home.cancelBookingMessageCombin'));
        }
      }
    },
    // 并单补料
    handleOpenNewReportCombined: function handleOpenNewReportCombined() {
      var _this17 = this;
      // if(this.isShow&&this.multipleSelection.length < 2 || this.multipleSelection.length >100){
      //   this.$message.warning(this.$t('home.warningJustOneTwo'))
      //   return false
      // }
      // if(!this.isShow&&this.selectList.length < 2 || this.selectList.length >100){
      //   this.$message.warning(this.$t('home.warningJustOneTWo'))
      //   return false
      // }
      if (this.isShow && this.multipleSelection.length < 1) {
        this.$message.warning(this.$t('home.warning'));
        return false;
      }
      if (!this.isShow && this.selectList.length < 1) {
        this.$message.warning(this.$t('home.warning'));
        return false;
      }
      var operateArr = [];
      this.isShow ? operateArr = this.multipleSelection : operateArr = this.selectList;
      if (operateArr.length === 1 && operateArr[0].pol !== 'CNSHK' && operateArr[0].pol !== 'CNNSA' && operateArr[0].pol !== 'CNTAG' && !operateArr[0].pol.startsWith('TH')) {
        this.$message.error(this.$t('home.statusCancelMessage'));
        return false;
      }
      if (operateArr.length === 1 && (operateArr[0].bookingType2 !== '1' || operateArr[0].blType !== '1')) {
        this.$message.warning(this.$t('home.cancelBookingMessageCombin'));
        return false;
      }
      if (operateArr.length > 1) {
        var data = operateArr.map(function (item) {
          return item.bookingHeadWebComId;
        });
        (0, _booking.combineDataValidate)(data).then(function (res) {
          if (res.success) {
            _this17.dataInfo = _this17.multipleSelection;
            _this17.mainId = null;
            _this17.combinDialogDialog = true;
          }
        });
      } else {
        var _data = {
          spliteCombinType: 1,
          id: operateArr[0].bookingHeadWebComId
        };
        (0, _newReports.getLoadSpliteDataMap)(_data).then(function (res) {
          res.data.forEach(function (item) {
            item.vesselCode = item.vessel;
            item.voyageNo = item.voyage;
            item.etd = item.etdStr;
          });
          _this17.dataInfo = res.data;
          _this17.mainId = operateArr[0].bookingHeadWebComId;
          _this17.combinDialogDialog = true;
        });
      }
    },
    justSelectOne: function justSelectOne(data) {
      if (data.length < 1) {
        this.$message.warning(this.$t('home.warning'));
        return false;
      }
      if (data.length > 1) {
        this.$message.warning(this.$t('home.warningJustOne'));
        return false;
      }
      return true;
    },
    goToPath: function goToPath(path) {
      var isSelectOne = false;
      var jumpBlNo = '';
      if (this.isShow) {
        console.log(this.multipleSelection, 'this.multipleSelection');
        isSelectOne = this.justSelectOne(this.multipleSelection);
        jumpBlNo = this.multipleSelection.length && this.multipleSelection[0].blNo || '';
      } else {
        console.log(this.selectList, 'this.selectList');
        isSelectOne = this.justSelectOne(this.selectList);
        jumpBlNo = this.selectList.length && this.selectList[0].blNo || '';
      }
      console.log(isSelectOne, 'isSelectOne000', path);
      if (isSelectOne) {
        this.$router.push({
          path: path,
          query: {
            blNo: jumpBlNo
          }
        });
      }
    },
    handleOpenVessel: function handleOpenVessel() {
      this.sailScheduleDialogVisible = true;
    },
    handOpenPrintSo: function handOpenPrintSo(row) {
      var _this18 = this;
      this.loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _booking.getUrlStrForPreviewSo)(row.bookingHeadWebComId).then(function (res) {
        if (res.success) {
          window.open(res.data);
        }
      }).finally(function () {
        _this18.loading.close();
      });
    },
    showViewSo: function showViewSo(row) {
      if (row.status == 1 || row.status == 5 || row.status == 4 || row.status == 13) {
        if (row.pol === 'CNSHK') {
          return true;
        }
      }
      return false;
    },
    showView: function showView(row) {
      if (row.status == 13 || row.status == 14) {
        var data = ['HKHKG', 'CNNSA', 'CNQZH', 'CNFAN', 'CNBHY', 'CNSZX', 'CNSHK'].includes(row.pol);
        if (data) {
          return true;
        }
      }
      if (row.status !== 3 && row.status !== 10) {
        var _data2 = ['CNSHA'].includes(row.pol);
        if (_data2) {
          return true;
        }
      }
      if (row.status !== 11 && row.status !== 0 && row.status !== 3 && row.status !== 10 && row.status !== 9 && row.status !== 14) {
        var _data3 = ['CNYNT', 'CNTAO', 'CNWEI', 'CNTXG', 'VNHPH', 'CNWEF'].includes(row.pol);
        if (_data3) {
          return true;
        }
      }
      if (row.status == 1 || row.status == 5 || row.status == 4) {
        var _data4 = ['CNNSA', 'CNDLC', 'CNSHK', 'CNTAG', 'CNFAN'].includes(row.pol);
        if (_data4) {
          return true;
        }
        if (row.pol.startsWith('TH')) {
          return true;
        }
      }
      if (row.pol.startsWith('KR')) {
        if (row.status === 1 || row.status === 5 || row.status === 4) {
          return true;
        }
      }
      return false;
    },
    showName: function showName(arr, Id) {
      var _this19 = this;
      if (arr instanceof Array) {
        var label = '';
        arr.some(function (item) {
          if (item.codeValue === String(Id)) {
            label = _this19.language === 'zh' ? item.displayValueCn : item.displayValue;
            return true;
          }
        });
        return label;
      }
    },
    handleSelectVessel: function handleSelectVessel() {
      this.handleSearch();
    },
    // 新增订舱
    handleAddBooking: function handleAddBooking(row) {
      this.$router.push({
        name: 'bookingSpaceDetail',
        params: {
          bookingInfo: row
        }
      });
    },
    changePort: function changePort(selectedRows) {
      this.form.pol = selectedRows.portCode;
    },
    convertHoursToDaysAndHours: function convertHoursToDaysAndHours(hours) {
      var days = Math.floor(hours / 24);
      var remainingHours = hours % 24;
      return "".concat(days, " \u5929 ").concat(remainingHours, " \u5C0F\u65F6");
    },
    handleOpen: function handleOpen() {
      this.$router.push({
        path: '/portContacts'
      });
    },
    changeSelect: function changeSelect(val) {
      this.caculateTime(val);
    },
    handleReset: function handleReset() {
      for (var key in this.listQuery) {
        if (key !== 'pageSize') {
          this.listQuery[key] = '';
        }
      }
      this.listQuery.currentPage = 1;
      this.listQuery.isTs = '0';
      this.listQuery.time = '';
      this.filterForm.selectTime = '1';
      this.filterForm.serviceLineCode = '';
      this.filterForm.vesselCode = '';
      this.radio = '1';
      this.currentFlag = '1';
      this.handleInitTime();
    },
    // changeTime(val){
    //   console.log(val,'时间的惦')
    //   this.caculateTime(val)
    // },
    setTime: function setTime() {
      var data = Object.assign({}, this.listQuery);
      if (this.currentFlag === '1') {
        data.etd = (0, _utils.parseTime)(data.etd, '{y}-{m}-{d} ');
        data.etdTo = (0, _utils.parseTime)(data.etdTo, '{y}-{m}-{d}');
        data.createdFrom = '';
        data.createdTo = '';
      } else {
        data.createdFrom = (0, _utils.parseTime)(data.createdFrom, '{y}-{m}-{d}');
        data.createdTo = (0, _utils.parseTime)(data.createdTo, '{y}-{m}-{d}');
        data.etd = '';
        data.etdTo = '';
      }
      return data;
    },
    handleSearch: function handleSearch() {
      var _this20 = this;
      var listQuery = this.listQuery;
      console.log('listQuery', listQuery);
      if (!listQuery.etd && !listQuery.etdTo && !listQuery.bkNo && !listQuery.blNo && !listQuery.vesselCode && !listQuery.voyageNo && !listQuery.voyageLeg && !listQuery.voyageNo && !listQuery.createdFrom && !listQuery.createdTo) {
        this.$message.warning(this.$t('home.searchMessage'));
        return;
      }
      var data = this.setTime();
      data.status ? data.status = data.status.join(',') : '';
      // data.etdTo = this.caculateTime(data.etdTo,4)
      // data.createdFrom = this.caculateTime(data.createdFrom,3)
      // data.createdTo = this.caculateTime(data.createdTo,4)
      this.tableLoading = true;
      (0, _booking.searhBookingHeadWebComHistory)(data).then(function (res) {
        if (res.success) {
          _this20.tableData = res.data && res.data.records;
          _this20.total = res.data && res.data.totalRecord;
          _this20.totalCrnt = res.data.moreAttributes.totalCrnt;
          _this20.checkedItems = _this20.tableData.map(function () {
            return false;
          });
        }
        _this20.tableLoading = false;
      }).catch(function () {
        _this20.tableLoading = false;
      });
    },
    changChekbox: function changChekbox() {
      console.log('Selected items:', this.selectedItems);
      // 在这里处理选中的项目，例如发送到服务器
    },
    handleAdd: function handleAdd() {
      this.id = '';
      this.initDialogVisible = true;
      this.disabledType = false;
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable && this.$refs.hotTable.resizeTo();
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleDouble: function handleDouble(_ref4) {
      var physicalRow = _ref4.physicalRow;
      this.handleEdit(physicalRow);
    },
    handleViewContract: function handleViewContract(row) {
      var data = this.tableData[row];
      this.id = data.id;
      this.disabledType = true;
      this.initDialogVisible = true;
    },
    handleEdit: function handleEdit(row) {
      var data = this.tableData[row];
      this.id = data.id;
      this.disabledType = false;
      this.initDialogVisible = true;
    },
    setInitDialogVisible: function setInitDialogVisible(val) {
      this.initDialogVisible = val;
    },
    columnRenderer: function columnRenderer(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      if (value) {
        td.setAttribute('title', value);
        td.innerHTML = value;
      } else {
        td.innerHTML = "";
      }
    },
    //  拆并单的不允许编辑补料明细
    getLookOneSupplyFlag: function () {
      var _getLookOneSupplyFlag = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(data) {
        var bookingHeadWebComId, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              bookingHeadWebComId = data.bookingHeadWebComId;
              _context5.next = 3;
              return (0, _newReports.supplementEditValidate)(bookingHeadWebComId);
            case 3:
              res = _context5.sent;
              if (!res.success) {
                _context5.next = 6;
                break;
              }
              return _context5.abrupt("return", res.data);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function getLookOneSupplyFlag(_x3) {
        return _getLookOneSupplyFlag.apply(this, arguments);
      }
      return getLookOneSupplyFlag;
    }()
  }
};